/**
 * Ce que l'élève rend : l'oral SEULEMENT quand le modèle déclare une étape audio et aucune étape
 * photo. Le test d'avant ("pas de photo → audio") faisait tomber sur l'oral tout modèle SANS étape
 * média — « Go exo » (steps = [chrono]), typiquement : l'élève voyait « Enregistrer mon travail » et
 * une icône micro sur un exercice écrit. Le repli sûr est la photo : « montre ton travail » vaut pour
 * tout, l'oral non.
 *
 * Déplacé tel quel de `student/activity/execute/` : seuls des types sont ajoutés.
 */
export type WorkMedium = "photo" | "audio"

type TemplateStep = { type?: string | null } | null | undefined

export const workMediumOf = (steps: TemplateStep[] | null | undefined): WorkMedium => {
    const hasStep = (type: string) => !!steps?.some((step) => step?.type === type)
    return hasStep("audio_video") && !hasStep("photo") ? "audio" : "photo"
}
